export const BASE_URL = "https://certificados.uni.app.br/backoffice/public";
